// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"aed373fd","535":"ed4edc3c","719":"1fd84cd6","727":"990d1427","766":"aa5137e1","913":"38b4bbaf","920":"6bb887b9"}[chunkId] + ".chunk.css";
};